export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium font-label tracking-wide mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              实时爆料 · 持续更新
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight tracking-tight mb-4">
              51爆料 - 全网热门爆料内容聚合平台
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading font-semibold mb-6">
              第一时间，第一现场，第一手爆料
            </p>

            <p className="text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              51爆料网汇聚全网最新最热的爆料内容，涵盖社会热点、行业动态、圈内秘闻与实时快讯。
              平台每日更新海量一手资讯，为用户提供快速直达的爆料浏览体验。无论是最新突发事件、
              深度行业揭秘，还是热门话题追踪，这里都是您获取真实爆料的首选入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-label">
                  24H
                </div>
                <div className="text-xs text-foreground-500 mt-1">全天候更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-label">
                  多领域
                </div>
                <div className="text-xs text-foreground-500 mt-1">内容全覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-label">
                  实名审核
                </div>
                <div className="text-xs text-foreground-500 mt-1">信息有保障</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleClick('#cards')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer font-label"
              >
                浏览最新爆料
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => handleClick('#contact')}
                className="w-full sm:w-auto px-8 py-3 bg-background-50 text-foreground-800 font-medium rounded-lg text-base border border-background-300 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer font-label"
              >
                我要投稿爆料
                <i className="ri-send-plane-line ml-2"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20editorial%20newsroom%20scene%20with%20warm%20amber%20and%20deep%20red%20accents%2C%20floating%20abstract%20documentary%20elements%2C%20layered%20typography%20fragments%20in%20Chinese%20style%2C%20soft%20dramatic%20lighting%20from%20above%2C%20clean%20modern%20minimalist%20composition%2C%20warm%20cream%20background%20with%20subtle%20texture%2C%20editorial%20photography%20aesthetic%2C%20high%20detail%2C%20professional%20journalism%20atmosphere&width=1040&height=780&seq=hero-main-51bl&orientation=landscape"
                alt="51爆料 - 全网热门爆料内容聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}